(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.crp-header header-menu').forEach(menu => {
   const details = menu.querySelector('details');
   const summary = details.querySelector('summary');
   let closeTimer;
   menu.addEventListener('pointerenter', event => {
     if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 990px)').matches) return;
     clearTimeout(closeTimer);
     document.querySelectorAll('.crp-header header-menu details[open]').forEach(other => {
       if (other !== details) { other.open = false; other.querySelector('summary').setAttribute('aria-expanded','false'); }
     });
     details.open = true;
     summary.setAttribute('aria-expanded','true');
   });
   menu.addEventListener('pointerleave', () => {
     closeTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) { details.open = false; summary.setAttribute('aria-expanded','false'); } }, 180);
   });
 });
  } catch(e) { console.error(e); }
})();

})();
